import { useUidAttribute } from "composables/useUidAttribute";
import { useSharedState } from "composables/useSharedState";
import { useHostAttribute } from "composables/useHostAttribute";
import { useTable } from "./useTable";
import { tableVariants } from "./Table.styles";
import type { TableProps } from "./TableProps";

export interface UseTableMainOptions {
  props: Readonly<TableProps>;
}

export const useTableMain = (options: UseTableMainOptions) => {
  const { props } = options;

  useUidAttribute();
  useSharedState(props);

  const { columnWidthStyle, getSelectedRows } = useTable();

  useHostAttribute("selected-rows", getSelectedRows);

  const classes = tableVariants(props);

  return { classes, columnWidthStyle };
};
